import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Terms.module.scss';
import { Link } from 'react-router-dom';

function Terms() {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <span className={styles.text}>{t('login.action.terms.info')}</span>
      <div>
        <Link to={'https://www.webfolio.com/terms-and-conditions/'}>
          <span className={styles.link}>{t('login.action.terms.term')}</span>
        </Link>
        <span className={styles.text}>&nbsp;{t('login.action.terms.and')}&nbsp;</span>
        <Link to={'https://www.webfolio.com/data-privacy/'}>
          <span className={styles.link}>{t('login.action.terms.privacy')}</span>
        </Link>
      </div>

    </div>
  )
}

export default Terms;
